import { useSyncExternalStore } from "react";
import { canv } from "@/canv/global";
import { VStack } from "@/shared/ui/Stack";
import type { WidgetListItemValue } from "../../types";
import type { VoteWindow } from "../../VoteWindow";
import { NewVoteWidgetsListItem } from "../NewVoteWidgetsListItem";
import styles from "./NewVoteList.module.css";

function useWidgetsList(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeWidgetsList, voteWindow.getWidgetsListSnapshot);
}

export function NewVoteList() {
    const widgetsList = useWidgetsList(canv.appInterface.voteWindow);

    const handleUpdateWidgetItem = (type: WidgetListItemValue, value: boolean) => {
        const result = widgetsList.map((widget) => {
            if (widget.value === type) {
                return { ...widget, selectedCount: value ? widget.candidateCount : 0 };
            }

            canv.appInterface.voteWindow.screen?.selectByType(type, value);

            return widget;
        });

        canv.appInterface.voteWindow.setWidgetsList(result);
    };

    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>Выбор объектов</p>
            <VStack fullWidth align="start" gap={18}>
                {widgetsList.map((widget) => (
                    <NewVoteWidgetsListItem
                        key={widget.value}
                        name={widget.name}
                        value={widget.value}
                        selectCount={widget.selectedCount}
                        candidateCount={widget.candidateCount}
                        onSelect={handleUpdateWidgetItem}
                    />
                ))}
            </VStack>
        </div>
    );
}

NewVoteList.whyDidYouRender = true;
